export const PROJECT_CREATE = "PROJECT_CREATE";
export const PROJECT_VIEW_ALL = "PROJECT_VIEW_ALL";
export const PROJECT_CREATE_ERROR = "PROJECT_CREATE_ERROR";
export const PROJECT_VIEW_ALL_ERROR = "PROJECT_VIEW_ALL_ERROR";
export const PROJECT_ASSIGN = "PROJECT_ASSIGN";
export const PROJECT_ASSIGN_ERROR = "PROJECT_ASSIGN_ERROR";
export const GET_PROJECT="GET_PROJECT"